//import {lazy, FC, Suspense} from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
//import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
//import {MenuTestPage} from '../pages/MenuTestPage'
//import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
//import {WithChildren} from '../../_metronic/helpers'
//import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import VictimaIndex from '../pages/Principal/Persona';
import PersonaIndex from '../pages/Catalogos/Persona';
import PersonaDetails from '../pages/Principal/Persona/detalles';
import PersonaEventos from '../pages/Principal/Persona/eventos';
import PersonaTestimonios from '../pages/Principal/Persona/testimonios';
import PersonaDocumentos from '../pages/Principal/Persona/documentos';
import PersonaFuentes from '../pages/Principal/Persona/fuentes';
import PersonaRelaciones from '../pages/Principal/Persona/relaciones';
import EntrevistaIndividual from '../pages/Testimonial/EntrevistaIndividual/entrevistaIndividual';
import CondicionesDiferenciadoras from '../pages/Catalogos/CondicionesDiferenciadoras';
import OrganizacionIndex from '../pages/Catalogos/Organizacion';
import GravesViolacionesIndex from '../pages/Catalogos/GravesViolaciones';
import Subcontextos from '../pages/Catalogos/Subcontextos';
//import EntrevistaIndividualIndex from '../pages/Testimonial/EntrevistaIndividual/index';
import EntrevistaIndex from '../pages/Testimonial/EntrevistaIndividual/index';
import DetallesWrapper from '../pages/Testimonial/EntrevistaIndividual/detallesWrapper';
//import DetallesEntrevista from '../pages/Testimonial/EntrevistaIndividual/detalles';
import {EntrevistaArchivos} from '../pages/Testimonial/EntrevistaIndividual/archivos';
import ReproductorTestimonio from '../pages/Testimonial/EntrevistaIndividual/detallesTestimonio/reproductorTestimonio';

import Home from '../pages/home';
import { Etiquetas } from '../pages/Testimonial/EntrevistaIndividual/etiquetas';
import { CatalogoEtiquetas } from '../pages/Catalogos/Etiquetas';
import { AnalisisContexto } from '../pages/Catalogos/Etiquetas/analisisContexto';
import { getAuth, useAuth } from '../modules/auth';
import { BusquedaAnalisisContexto } from '../pages/Etiquetas/analisisContexto';
import { BusquedaEstrategias } from '../pages/Etiquetas/estrategias';
import { BusquedaConsecuencias } from '../pages/Etiquetas/consecuencias';
import { BusquedaCausas } from '../pages/Etiquetas/causas';
import { BusquedaFactores } from '../pages/Etiquetas/factores';
import TranscripcionVisor from '../pages/Testimonial/EntrevistaIndividual/detallesTestimonio/transcripcionVisor';
import Graph from '../Components/D3js/Graph';

const PrivateRoutes = () => {
  const { currentUser } = useAuth()
  /*const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))*/
  //const auth = JSON.parse();
  //console.log(currentUser)
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route path='Home/' element={<Home />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='/Victimas' element={<VictimaIndex />} />
        <Route path='/Personas' element={<PersonaIndex />} />
        <Route path='/Organizaciones' element={<OrganizacionIndex />} />
        <Route path='/GravesViolaciones' element={<GravesViolacionesIndex />} />        
        <Route path='/Persona/Eventos/:id' element={<PersonaEventos />} />
        <Route path='/Persona/Testimonios/:id' element={<PersonaTestimonios />} />
        <Route path='/Persona/Documentos/:id' element={<PersonaDocumentos />} />
        <Route path='/Persona/Detalles/:id' element={<PersonaDetails />} />
        <Route path='/Persona/Fuentes/:id' element={<PersonaFuentes />} />
        <Route path='/Persona/Relaciones/:id' element={<PersonaRelaciones />} />
        <Route path='/CondicionesDiferenciadoras/' element={<CondicionesDiferenciadoras />} />
        <Route path='/Testimonial/Entrevista/' element={<EntrevistaIndividual />} />
        <Route path='/Testimonial/Detalles/:id' element={<DetallesWrapper />} />        
        <Route path='/Testimonial/Archivos/:id' element={<EntrevistaArchivos />} />
        <Route path='/Testimonial/' element={<EntrevistaIndex />} />
        <Route path='/Subcontextos/' element={<Subcontextos />} />
        <Route path='/Testimonial/Etiquetas/:id' element={<Etiquetas />} />
        <Route path='/CatalogoEtiquetas/' element={<CatalogoEtiquetas />} />
        <Route path='/CatalogoEtiquetas/AnalisisContexto' element={<AnalisisContexto />} />
        <Route path='/Etiquetas/AnalisisContexto' element={<BusquedaAnalisisContexto />} />
        <Route path='/Etiquetas/Estrategias' element={<BusquedaEstrategias />} />
        <Route path='/Etiquetas/Consecuencias' element={<BusquedaConsecuencias />} />
        <Route path='/Etiquetas/Causas' element={<BusquedaCausas />} />
        <Route path='/Etiquetas/Factores' element={<BusquedaFactores />} />
        <Route path='/Graficos/Force' element={<Graph />} />
      </Route>
      <Route path='/Testimonial/Audio/:id' element={<ReproductorTestimonio id={''} />} />
      <Route path='/Testimonial/Transcripcion/:nombre/:nombreOriginal' element={<TranscripcionVisor />} />
    </Routes>
  )
}

export { PrivateRoutes }